var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9165 8.88511C16.9165 14.1642 11.0602 19.6621 9.09368 21.3601C8.91048 21.4979 8.68747 21.5724 8.45825 21.5724C8.22904 21.5724 8.00603 21.4979 7.82283 21.3601C5.85628 19.6621 0 14.1642 0 8.88511C0 6.64182 0.891135 4.4904 2.47736 2.90415C4.06359 1.3179 6.21498 0.426758 8.45825 0.426758C10.7015 0.426758 12.8529 1.3179 14.4391 2.90415C16.0254 4.4904 16.9165 6.64182 16.9165 8.88511Z",
    fill: "#F42F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45822 12.0566C10.21 12.0566 11.6301 10.6365 11.6301 8.88474C11.6301 7.13297 10.21 5.71289 8.45822 5.71289C6.70646 5.71289 5.28638 7.13297 5.28638 8.88474C5.28638 10.6365 6.70646 12.0566 8.45822 12.0566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9a172a94e6788a77fbd6314cd810dcbf.svg";
export { ForwardRef as ReactComponent };